import {
	AfterViewInit,
	Component,
	ComponentFactoryResolver, ComponentRef,
	ElementRef,
	EventEmitter,
	OnInit,
	ViewChild, ViewContainerRef
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { AddEditBrandComponent } from '../../add-edit-brand/add-edit-brand.component';
import { BrandsDataSource } from "../../../services/data-sources/brands.datasource";
import { BrandsService } from "../../../services/brands.service";
import { fromEvent, merge } from "rxjs";
import { debounceTime, distinctUntilChanged, tap } from "rxjs/operators";
import { ConfirmPopupComponent } from "../../../common/confirm-popup/confirm-popup.component";
import { Brand } from "../../../interfaces/brand.interface";
import { SelectionModel } from '@angular/cdk/collections';
import { MatSnackBar } from '@angular/material/snack-bar';
import {AuthService} from "../../../services/auth/auth.service";
import {FireworksService} from "../../../services/fireworks.service";
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'app-print-fireworks',
    templateUrl: './print-fireworks.component.html',
    styleUrls: ['./print-fireworks.component.scss'],
    standalone: false
})
export class PrintFireworksComponent implements OnInit, AfterViewInit {
	fireworks: any;
	constructor() {

	}
	ngAfterViewInit() {
	}
	ngOnInit(){

	}
}
